import { SaveOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import 'antd/dist/reset.css';
import imageCompression from 'browser-image-compression';
import React, { useState } from 'react';
import Compress from 'react-image-file-resizer';
import Modal from 'react-modal';
import 'tui-color-picker/dist/tui-color-picker.css';
import 'tui-image-editor/dist/tui-image-editor.css';
import ImageEditor from '../../../components/ImageEditor';

const myTheme = {
  'header.display': 'none'
};

export default function Editor({ image, title, onSave, onRestore }) {
  const [modalIsOpen, setIsOpen] = useState(true);
  const [saveImage, setSaveImage] = useState(false);
  const tui = React.useRef(null);

  const closeModal = () => {
    onSave('');
    setIsOpen(false);
  };

  const restore = async () => {
    onRestore();
    setIsOpen(false);
  };

  const logImageContent = async () => {
    setSaveImage(true);
    const instance = tui.current.getInstance();
    const dataURL = instance.toDataURL();
    const blob = await imageCompression.canvasToFile(instance);
    Compress.imageFileResizer(
      blob, // the file from input
      480, // width
      480, // height
      'JPEG', // compress format WEBP, JPEG, PNG
      70, // quality
      0, // rotation
      (uri) => {
        onSave({
          img: dataURL,
          blob: uri
        });
      },
      'blob' // blob or base64 default base64
    );
    setIsOpen(false);
  };

  return (
    <>
      <Modal isOpen={modalIsOpen}>
        <ImageEditor
          ref={tui}
          includeUI={{
            loadImage: {
              path: image,
              name: title
            },
            theme: myTheme,
            locale,
            menu: ['shape', 'draw', 'text'],
            initMenu: 'draw',
            uiSize: {
              width: '100%',
              height: '100%'
            },
            menuBarPosition: 'left'
          }}
          cssMaxHeight={500}
          cssMaxWidth={700}
          selectionStyle={{
            cornerSize: 20,
            rotatingPointOffset: 70
          }}
        />
        <Button
          type="link"
          shape="round"
          style={{ position: 'absolute', top: '2em', right: '19em' }}
          onClick={restore}
        >
          Restaurar
        </Button>
        <Button
          type="default"
          shape="round"
          style={{ position: 'absolute', top: '2em', right: '12em' }}
          onClick={closeModal}
        >
          Cancelar
        </Button>
        <Button
          type="primary"
          shape="round"
          icon={<SaveOutlined />}
          loading={saveImage}
          style={{ position: 'absolute', top: '2em', right: '4em' }}
          onClick={logImageContent}
        >
          Guardar
        </Button>
      </Modal>
    </>
  );
}

const locale = {
  'Delete-all': 'Borrar',
  Text: 'Texto',
  Draw: 'Dibujar',
  Shape: 'Forma',
  Delete: 'Borrar',
  Reset: 'Volver al principio',
  Undo: 'Volver atras',
  Redo: 'Volver adelante',
  Rectangle: 'Rectangulo',
  Circle: 'Circulo',
  Triangle: 'Triangulo',
  Fill: 'Color interno',
  Stroke: 'Color borde',
  Free: 'Dibujo libre',
  Straight: 'Linea Recta',
  Underline: 'Subrayado',
  Left: 'Izquierda',
  Center: 'Centro',
  Bolt: 'Negrita',
  Right: 'Derecha',
  ZoomIn: 'Acercar',
  ZoomOut: 'Alejar',
  Hand: 'Mover',
  History: 'Historial de acciones'
};
